module.exports = __webpack_public_path__ + "static/018-fb1dd3f5de1c81771d1d8dbfb24a44f1.jpg";